/**
 * @module actions/settings
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get contact information from api
 * @return {Promise} Axios promise
 */
export function getContactInformation () {
  let url = API_URL + '/Setting/Contact/Get'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save contact information to api
 * @return {Promise} Axios promise
 */
export function saveContactInformation (data) {
  let url = API_URL + '/Setting/Contact/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get punchclock information from api
 * @return {Promise} Axios promise
 */
export function getPunchClockInformation (shopId) {
  let url = API_URL + '/Setting/PunchClock/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save punchclock information to api
 * @return {Promise} Axios promise
 */
export function savePunchClockInformation (data) {
  let url = API_URL + '/Setting/PunchClock/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get forsi information from api
 * @return {Promise} Axios promise
 */
export function getForsiInformation (shopId) {
  let url = API_URL + '/Setting/Forsi/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save forsi information to api
 * @return {Promise} Axios promise
 */
export function saveForsiInformation (data) {
  let url = API_URL + '/Setting/Forsi/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get invoicing information from api
 * @return {Promise} Axios promise
 */
export function getInvoicingInformation (shopId) {
  let url = API_URL + '/Setting/Invoicing/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save invoicing information to api
 * @return {Promise} Axios promise
 */
export function saveInvoicingInformation (data) {
  let url = API_URL + '/Setting/Invoicing/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get product numbers report information from api
 * @return {Promise} Axios promise
 */
export function getProductNumbersReport () {
  let url = API_URL + '/Setting/Invoicing/ProductNumbersReport/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get product numbers other information from api
 * @return {Promise} Axios promise
 */
export function getProductNumbers (shopId) {
  let url = API_URL + '/Setting/Invoicing/ProductNumbers/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save product numbers report information to api
 * @return {Promise} Axios promise
 */
export function saveProductNumbersReport (data) {
  let url = API_URL + '/Setting/Invoicing/ProductNumbersReport/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Save product numbers other information to api
 * @return {Promise} Axios promise
 */
export function saveProductNumbers (data) {
  let url = API_URL + '/Setting/Invoicing/ProductNumbers/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get dracar company stores information from api
 * @return {Promise} Axios promise
 */
export function getDracarStores (shopId) {
  let url = API_URL + '/Setting/Invoicing/DracarStores/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save dracar company stores information to api
 * @return {Promise} Axios promise
 */
export function saveDracarStores (data) {
  let url = API_URL + '/Setting/Invoicing/DracarStores/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get closing days information from api
 * @return {Promise} Axios promise
 */
export function getClosingDaysInformation (shopId) {
  let url = API_URL + '/Setting/ClosingDays/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save closing days information to api
 * @return {Promise} Axios promise
 */
export function saveClosingDaysInformation (data) {
  let url = API_URL + '/Setting/ClosingDays/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get process time information from api
 * @return {Promise} Axios promise
 */
export function getProcessTimeInformation (shopId) {
  let url = API_URL + '/Setting/ProcessTime/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save process time information to api
 * @return {Promise} Axios promise
 */
export function saveProcessTimeInformation (data) {
  let url = API_URL + '/Setting/ProcessTime/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get BufferTime Distribution from api
 * @return {Promise} Axios promise
 */
export function getBufferTimeDistribution () {
  let url = API_URL + '/Setting/BufferTimeDistribution/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save BufferTime Distribution to api
 * @return {Promise} Axios promise
 */
export function saveBufferTimeDistribution (data) {
  let url = API_URL + '/Setting/BufferTimeDistribution/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get order inspection information from api
 * @return {Promise} Axios promise
 */
export function getOrderInspectionInformation (shopId) {
  let url = API_URL + '/Setting/OrderInspection/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save order inspection information to api
 * @return {Promise} Axios promise
 */
export function saveOrderInspectionInformation (data) {
  let url = API_URL + '/Setting/OrderInspection/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get booking information from api
 * @return {Promise} Axios promise
 */
export function getBookingInformation (shopId) {
  let url = API_URL + '/Setting/Booking/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save booking information to api
 * @return {Promise} Axios promise
 */
export function saveBookingInformation (data) {
  let url = API_URL + '/Setting/Booking/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get Delivery information from api
 * @return {Promise} Axios promise
 */
export function getAgreementsDeliveryInformation (customerId, shopId) {
  let url = API_URL + '/Setting/Delivery/Agreement/Get/'
  let data = {
    CustomerId: customerId,
    ShopId: shopId,
    PriceModelId: 0
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get Delivery information from api
 * @return {Promise} Axios promise
 */
export function getDeliveryInformation (customerId, shopId, priceModelId) {
  let url = API_URL + '/Setting/Delivery/Get'
  if (priceModelId === 'undefined' || priceModelId === 'null') priceModelId = 0
  let data = {
    CustomerId: customerId,
    ShopId: shopId,
    PriceModelId: priceModelId
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Save Delivery information to api
 * @return {Promise} Axios promise
 */
export function saveDeliveryInformation (data) {
  let url = API_URL + '/Setting/Delivery/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get Notification information from api
 * @return {Promise} Axios promise
 */
export function getNotificationInformation () {
  let url = API_URL + '/Setting/Notification/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save Notification information to api
 * @return {Promise} Axios promise
 */
export function saveNotificationInformation (data) {
  let url = API_URL + '/Setting/Notification/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get ViewSetting information from api
 * @return {Promise} Axios promise
 */
export function getViewSettings (shopId) {
  let url = API_URL + '/Setting/ViewSettings/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save ViewSetting information to api
 * @return {Promise} Axios promise
 */
export function saveViewSettings (data) {
  let url = API_URL + '/Setting/ViewSettings/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get SupportAccess information from api
 * @return {Promise} Axios promise
 */
export function getSupportAccess (shopId) {
  let url = API_URL + '/Setting/SupportAccess/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save SupportAcces information to api
 * @return {Promise} Axios promise
 */
export function saveSupportAccess (data) {
  let url = API_URL + '/Setting/SupportAccess/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get PaintTool information from api
 * @return {Promise} Axios promise
 */
export function getPaintToolInformation (shopId) {
  let url = API_URL + '/Setting/PaintTool/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save PaintTool information to api
 * @return {Promise} Axios promise
 */
export function savePaintToolInformation (data) {
  let url = API_URL + '/Setting/PaintTool/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get CarRental information from api
 * @return {Promise} Axios promise
 */
export function getCarRentalInformation (shopId) {
  let url = API_URL + '/Setting/CarRental/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save CarRental information to api
 * @return {Promise} Axios promise
 */
export function saveCarRentalInformation (data) {
  let url = API_URL + '/Setting/CarRental/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get ProcessManagement information from api
 * @return {Promise} Axios promise
 */
export function getProcessManagementInformation (shopId) {
  let url = API_URL + '/Setting/ProcessManagement/Get/' + shopId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save ProcessManagement information to api
 * @return {Promise} Axios promise
 */
export function saveProcessManagementInformation (data) {
  let url = API_URL + '/Setting/ProcessManagement/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get BookingPortal information from api
 * @return {Promise} Axios promise
 */
export function getBookingPortalInformation () {
  let url = API_URL + '/Setting/BookingPortal/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save BookingPortal information to api
 * @return {Promise} Axios promise
 */
export function saveBookingPortalInformation (data) {
  let url = API_URL + '/Setting/BookingPortal/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get CarOwnerPortal information from api
 * @return {Promise} Axios promise
 */
export function getCarOwnerPortalInformation () {
  let url = API_URL + '/Setting/CarOwnerPortal/Get'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save CarOwnerPortal information to api
 * @return {Promise} Axios promise
 */
export function saveCarOwnerPortalInformation (data) {
  let url = API_URL + '/Setting/CarOwnerPortal/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get StatusNotification information from api
 * @return {Promise} Axios promise
 */
export function getStatusNotificationInformation () {
  let url = API_URL + '/Setting/CarOwnerNotificationSettings/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save StatusNotification information to api
 * @return {Promise} Axios promise
 */
export function saveStatusNotificationInformation (data) {
  let url = API_URL + '/Setting/CarOwnerNotificationSettings/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Save StatusNotification information to api
 * @return {Promise} Axios promise
 */
export function deleteStatusNotification (data) {
  let url = API_URL + '/Setting/CarOwnerNotificationSettings/Delete'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Save StatusNotification information to api
 * @return {Promise} Axios promise
 */
export function addStatusNotification () {
  let url = API_URL + '/Setting/CarOwnerNotificationSettings/Add'
  return dispatch => {
    return axios.post(url)
  }
}

/**
 * @description GET Setting Portal Styling
 * @return {Promise} Axios promise
 */
export function getPortalStyling () {
  return dispatch => {
    return axios.get(`${API_URL}/CompanyStyling/Get`)
  }
}

/**
 * @description Save Setting Portal Styling
 * @return {Promise} Axios promise
 */
export function postPortalStyling (data) {
  return dispatch => {
    return axios.post(`${API_URL}/CompanyStyling/Post`, data)
  }
}

/**
 * @description get Data By OrderId
 * @return {Promise} Axios promise
 */
export function getDataByOrderId (id) {
  return dispatch => {
    return axios.get(`${API_URL}/CarOwnerPortal/CarOwnerPortalLogging/GetAllByOrderId/${id}`)
  }
}

/**
 * @description get Setting Portal Styling
 * @return {Promise} Axios promise
 */
export function getStylePortalWeb () {
  return dispatch => {
    return axios.get(`${API_URL}/CompanyStyling/Get`)
  }
}
/**
 * @description get logo
 * @return {Promise} Axios promise
 */
export function getLogoPortalStyling (id) {
  return dispatch => {
    return axios.get(`${API_URL}/CompanyStyling/GetLogo`)
  }
}

/**
 * @description set notification types (email/sms) allowed to send to car owner
 * @return {Promise} Axios promise
 */
export function updateAllowNotifications (data) {
  return dispatch => {
    return axios.post(`${API_URL}/CarOwnerPortal/NotificationsAllowed/Post`, data)
  }
}

/**
 * @description set IsRead OrderData
 * @return {Promise} Axios promise
 */
export function updateNotificationRead (data) {
  return dispatch => {
    return axios.post(`${API_URL}/CarOwnerPortal/NotificationRead/Post/`, data)
  }
}

/**
 * @description get accounting system field
 * @return {Promise} Axios promise
 */
export function getAccountingSystemField () {
  return dispatch => {
    return axios.get(`${API_URL}/Setting/Invoicing/GetAccountingSystemField`)
  }
}

/**
 * @description delete accounting system field
 * @return {Promise} Axios promise
 */
export function deleteAccountingSystemField (id) {
  return dispatch => {
    return axios.post(`${API_URL}/Setting/Invoicing/DeleteAccountingSystemField/Post/${id}`)
  }
}

/**
 * @description update accounting system field
 * @return {Promise} Axios promise
 */
export function updateAccountingSystemField (data) {
  return dispatch => {
    return axios.post(`${API_URL}/Setting/Invoicing/UpdateAccountingSystemField/Post`, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/settings.js